<template>
  <div class="case">
    <div class="case-title">
      <span class="case-title-text">杭州市滨文小学——比起成果,我们更想谈谈为什么要重视"AI+科学实验"</span>
    </div>
    <div class="case-line"></div>
    <div class="case-main">
      <div class="case-section">
        <p class="case-section__content">
          余嘉辉老师的《测量水沸腾和结冰时的温度》被评为浙江省省级实验教学类"基础教育精品课"。
        </p>
        <p class="case-section__content">
          基于校内实验案例输出的论文《人工智能助力科学实验教学实践创新》在《中国信息技术教育》杂志正式发表。
        </p>
      </div>
      
      <div class="case-images">
        <div class="case-image-placeholder" >
          <img src="@/assets/images/case/case2_1.jpeg" alt="case2-1">
        </div>
        <div class="case-image-placeholder" >
          <img src="@/assets/images/case/case2_2.png" alt="case2-2">
        </div>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">一、从"好奇的孩子"到"会做实验的孩子"：与学校文化高度同频的AI实验室</h3>
        <p class="case-section__content">
          杭州市滨文小学一直有一句共识："自信高于能力、好奇重于知识、快乐胜于第一。"这与央馆AI科学实验室鼓励"以学生探究为中心"高度契合：用智能工具拓展学生的科学视野，用可视化数据让孩子们真正"看得懂、说得清、敢质疑"。校训"梦想成就未来，行动积淀丰硕"，在央馆AI科学实验室里落到了最具体的行动——一次次设计实验、采集数据、反复验证，学生的梦想不再停留在口号，而是在每一次按下"开始测量"的瞬间被一步步兑现。
        </p>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">二、用AI重构一堂科学实验课：从"讲好原理"到"做好实验"</h3>
        <p class="case-section__content">
          在《智能技术支持下小学科学精准教学的实践》主题公开课与日常教学中，央馆AI科学实验室帮助教师把科学课从"演示实验"升级为"研究型实验"。
        </p>
        <p class="case-section__content">
          以省级基础教育精品课《测量水沸腾和结冰时的温度》为例，央馆AI实验室通过数字传感器和实时曲线，让原本抽象的"水的沸点、冰点"变成孩子能"看见变化、记录全过程、提出假设"的数据旅程。
        </p>
        <div class="case-images">
          <div class="case-image-placeholder">
            <img src="@/assets/images/case/case2_3.png" alt="case2-3">
          </div>
          <div class="case-image-placeholder">
            <img src="@/assets/images/case/case2_4.png" alt="case2-4">
          </div>
        </div>
        <p class="case-section__content">
          AI辅助生成实验报告框架，学生不再只写"结论抄答案"，而是被引导去描述"研究问题—实验设计—数据记录—现象解释—误差分析"，逐步形成科学研究的基本结构思维。
        </p>
        <p class="case-section__content">
          "借助AI工具，孩子们现在习惯拿着数据说话，而且课中课后我都能观察到学生的实验过程，可以精准定位实验中哪里出现了测量偏差，方便后续对他们进行分层指导。"授课教师余嘉辉反馈。
        </p>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">三、从一节课到一篇论文：用成果证明AI实验室的教学与科研价值</h3>
        <p class="case-section__content">
          央馆AI科学实验室的价值，已经不止体现在一两节"精彩的公开课"上，而是逐步沉淀为可复制、可推广的实践经验。
        </p>
        <p class="case-section__content">
          《测量水沸腾和结冰时的温度》被评为浙江省省级实验教学类"基础教育精品课"，并推送至教育部参加"基础教育精品课"遴选，背后是一整套"AI+数字化实验"的教学设计逻辑与实践路径。依托央馆AI科学实验室实践形成的论文《人工智能助力科学实验教学实践创新》，在11月份最新版《中国信息技术教育》杂志正式发表，已经转化成可交流的研究成果。
        </p>
        <p class="case-section__content">
          AI实验室不只是"买了一套设备"，而是帮助学校真正走上"教学—研究—再实践"的发展路径，从课例到课题，从数据到论文，也让学校的每一次探索都有抓手、有依据、有成果。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Case2"
}
</script>
<style lang="scss" scoped>
.case {
  width: 1185px;
  margin: 0 auto;
  background: #FFFFFF;
  padding: 32px;
  
  &-title {
    font-size: 24px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #262626;
  }
  
  &-line {
    width: 1120px;
    height: 1px;
    margin: 32px auto;
    background: #E5E5E5;
  }
  
  &-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  &-images {
    display: flex;
    gap: 20px;
    margin: 16px 0;
    align-items: stretch;
  }
  
  &-image-placeholder {
    flex: 0 0 auto;
    height: 300px;
    min-width: 0;
    background: #F5F5F5;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  
  &-section {
    display: flex;
    flex-direction: column;
    gap: 16px;

   
    
    &__title {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      color: #262626;
      margin: 0;
    }
    
    &__content {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0.01em;
      color: #262626;
    }
  }
}
</style>

